export default "__VITE_ASSET__1fd6d171__"